import React, {useState, useEffect} from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useData } from '../../dataContext';
import {Navbar, Nav, NavDropdown} from 'react-bootstrap';


const CsrReview =(props) => {

    const {id} = useParams();
    const history = useHistory();
    const { dataAll} = useData();
    const [review,setReview] = useState(null);

    //data download & context save here
    useEffect(() => {
        if(dataAll){
            getReviewFromId();
        }
    },[dataAll])

    const getReviewFromId = () =>{

        if (!dataAll) return -1
        
        let temp = dataAll["csrReviews"].filter(x=>x["reviewId"].toString()===id.toString())

        if(temp.length>0){
            setReview({...temp[0]})
        }
        
        return -1
    }

    const navBarStandard = () =>{

        return(
        <Navbar style={{ backgroundColor:'black', marginBottom:"3vh"}}>
            <Navbar.Brand style={{fontSize:"2vh", width:"15vw"}}>
                <div className="row">
                    <div className="col-6">
                        <span style={{color:'white',fontSize:"3vh"}}>Contractor and Service Provider Review</span>
                    </div>
                </div>
            </Navbar.Brand>
            <Navbar.Toggle />
            <Navbar.Collapse className="justify-content-end">
                <div className="row" style={{paddingRight:"2vw"}}>
                    <div className="col-4" >
                        <img style={{width:"15vw"}}src="https://cloud-1de12d.becdn.net/media/iW=261&iH=56&oX=0&oY=0&cW=260&cH=56/126163781c08429997f2007c128dc609/1751.png"></img>
                    </div>
                </div>
            </Navbar.Collapse>
        </Navbar>
        )


    }

    if (!review) return null

    return (
        <>
            {navBarStandard()}

            <div className="container" style={{marginLeft:"5vw", marginTop:"6vh"}}>
                <div className="row mb-3">
                    <div className="col-2"><span style={{fontWeight:600}}>Service Provider:</span></div>
                    <div className="col-6">{review["serviceProvider"]}</div>
                </div>                
                <div className="row mb-3">
                    <div className="col-2"><span style={{fontWeight:600}}>Reviewer:</span></div>
                    <div className="col-6">{review["reviewer"]}</div>
                </div>
                <div className="row mb-3">
                    <div className="col-2"><span style={{fontWeight:600}}>Review Date:</span></div>
                    <div className="col-6">{review["reviewDate"]}</div>
                </div>
                <div className="row mb-3">
                    <div className="col-2"><span style={{fontWeight:600}}>Review:</span></div>
                    <div className="col-6">{review["review"]}</div>
                </div>                                
 
            </div>
        </>
    );
}

export default CsrReview;